export default "__VITE_ASSET__Br$t4$vg__"